export enum HeaderStyleEnum {
  HomePage = 'home-page',
  Default = 'default',
  Support = 'support',
}